import type { I18nDict } from '../types.ts'

export const it: I18nDict = {
  app_name: 'ZION',
  settings_title: 'Impostazioni',
  section_language: 'Lingua',
  section_identity: 'Identità locale',
  section_updates: 'Aggiornamento app',
  section_notifications: 'Notifiche',
  section_theme: 'Tema visivo',
  section_backup: 'Backup chat',
  section_privacy_network: 'Privacy rete',
  section_media: 'Contenuti multimediali',
  section_security: 'Sicurezza & password',
  section_change_password: 'Cambio Master Password',
  section_2fa: 'Autenticazione a due fattori (2FA)',
  section_sound: 'Suoni in-chat',
  section_exit: 'Chiusura & distruzione dati',
  settings_change_password_hint:
    'La nuova password ri-cifra le chiavi e i dati sensibili salvati in locale (vault AES-GCM).',
  settings_pwd_current: 'Password attuale',
  settings_pwd_new: 'Nuova password',
  settings_pwd_confirm: 'Conferma nuova password',
  settings_btn_change_password: 'Aggiorna password',
  settings_pwd_working: 'Aggiornamento in corso…',
  settings_pwd_ok: 'Password aggiornata e vault ri-cifrato ✓',
  settings_pwd_err_short: 'La nuova password deve avere almeno 8 caratteri.',
  settings_pwd_err_mismatch: 'Nuova password e conferma non coincidono.',
  settings_pwd_err_wrong: 'Password attuale non corretta.',
  settings_pwd_err_identity: 'Identità incompleta — impossibile cifrare il vault.',
  settings_pwd_err_generic: 'Impossibile cambiare la password.',
  settings_2fa_hint:
    'Usa Google Authenticator, Authy o un’app TOTP compatibile. Il segreto resta solo su questo dispositivo.',
  settings_2fa_on: '2FA attiva',
  settings_2fa_off: '2FA disattivata',
  settings_btn_enable_2fa: 'Abilita 2FA (Google Authenticator / Authy)',
  settings_2fa_scan: 'Inquadra il QR con l’app di autenticazione, poi inserisci il codice a 6 cifre.',
  settings_2fa_secret: 'Oppure inserisci manualmente questo segreto:',
  settings_2fa_confirm_code: 'Codice di verifica (6 cifre)',
  settings_btn_confirm_2fa: 'Conferma e attiva 2FA',
  settings_btn_disable_2fa: 'Disattiva 2FA',
  settings_2fa_confirm_ok: '2FA attivata ✓',
  settings_2fa_confirm_fail: 'Codice non valido — riprova.',
  settings_2fa_disable_title: 'Disattivare 2FA?',
  settings_2fa_disable_body: 'L’accesso richiederà di nuovo solo la master password.',
  settings_sound_hint: 'Volume degli effetti sonori quando ricevi o invii messaggi con l’app aperta.',
  toggle_sound_mute: 'Muto / Disattiva suoni in chat',
  hint_sound_mute: 'Se ON, nessun beep in-chat (le notifiche di sistema non sono interessate).',
  settings_sound_volume: 'Volume effetti',
  settings_btn_sound_test: 'Prova suono',
  settings_sound_test_ok: 'Suono riprodotto.',
  settings_sound_test_fail: 'Impossibile riprodurre — verifica volume sistema e che il muto sia OFF.',
  auth_totp_title: 'Codice 2FA',
  auth_totp_hint: 'Inserisci il codice a 6 cifre dalla tua app di autenticazione.',
  auth_totp_code_label: 'Codice TOTP',
  auth_totp_wrong: 'Codice 2FA non valido.',
  toggle_external_links: 'Ricezione e visione link esterni',
  hint_external_links:
    'Se OFF: nessuna anteprima link in chat e impossibile aprire URL esterni (protezione tracciamento IP).',
  toggle_auto_media: 'Ricezione automatica media e documenti',
  hint_auto_media:
    'Se OFF: foto, video e file non si scaricano in background — tocca manualmente in chat.',
  toggle_require_unlock: "Password all'apertura dell'app",
  hint_require_unlock: 'Se ON, la password master è richiesta ogni volta che apri ZION.',
  toggle_wipe_exit: 'Wipe dati su Exit',
  hint_wipe_exit: "Se ON, chiudendo l'app si cancella cache RAM temporanea e dati di sessione.",
  btn_exit: 'Exit',
  btn_delete_all: 'ELIMINA TUTTI I DATI',
  btn_lock: 'Blocca app',
  btn_back: 'Indietro',
  warn_disable_password_title: '⚠️ ATTENZIONE',
  warn_disable_password_body:
    'Disattivando la password di apertura, chiunque prenda in mano il tuo dispositivo potrà leggere i tuoi messaggi cifrati. Sicuro di voler continuare?',
  warn_delete_all_1: "Vuoi davvero distruggere l'intero database? Questa azione è irreversibile.",
  warn_delete_all_2:
    'Conferma finale: tutte le chat, chiavi private e impostazioni saranno eliminate per sempre.',
  link_blocked: 'Link esterno bloccato (impostazioni privacy).',
  lang_welcome_title: 'Benvenuto in ZION',
  lang_welcome_sub: 'Scegli la lingua',
  lang_continue: 'Continua',
  settings_language_label: 'Lingua app',

  auth_unlock_title: 'Sblocca',
  auth_or_password: '— oppure sblocca con password —',
  auth_password_master: 'Password master',
  auth_unlock_btn: 'Sblocca',
  auth_verifying: 'Verifica…',
  auth_wrong_password: 'Password errata',
  auth_unlocked: 'Sbloccato ✓',

  auth_access_title: 'Accedi a ZION',
  auth_beta_spots: 'Beta gratuita · posti rimasti:',
  auth_beta_full: 'Beta piena ({max} utenti). Riprova più tardi.',
  auth_beta_free: 'Beta gratuita · accesso senza licenza',
  auth_or_create: '— oppure crea una nuova identità —',
  auth_password_min: 'Password (min. 8 caratteri)',
  auth_password_confirm: 'Conferma password',
  auth_privacy_check: 'Ho letto la',
  auth_privacy_link: 'Privacy Policy',
  auth_terms_check: 'Accetto i',
  auth_terms_link: 'Termini di servizio',
  auth_password_local_hint: 'La password non lascia mai questo dispositivo. Nessun account server.',
  auth_create_identity: 'Crea identità',
  auth_accept_legal_err: 'Accetta Privacy e Termini per continuare',
  auth_generating_keys: 'Generazione chiavi e sessione…',
  auth_generating_identity: 'Generazione identità anonima…',
  auth_generating_detail: 'Chiavi ECDH · nickname · sessione socket · codice ZN-',
  auth_you_are: 'Sei',
  auth_daily_suffix_hint: 'Il suffisso giornaliero cambia ogni UTC. Per accoppiarti usa il codice ZN- in Home.',
  auth_enter: 'Entra in ZION',
  auth_starting: 'Avvio…',

  auth_restore_title: 'Ripristina backup',
  auth_restore_hint:
    'Hai già un backup cifrato? Recupera identità, contatti e chat (es. dopo aver cancellato la cache).',
  auth_restore_file: 'File backup (.enc / .enc.json)',
  auth_restore_pass: 'Passphrase backup',
  auth_restore_pass_ph: 'Passphrase usata in export',
  auth_restore_btn: 'Ripristina backup',
  auth_restore_pick_file: 'Seleziona un file backup (.enc o .enc.json).',
  auth_restore_need_pass: 'Inserisci la passphrase.',
  auth_restoring: 'Ripristino…',
  auth_file_prefix: 'File:',

  common_accept: 'Accetta',
  common_reject: 'Rifiuta',
  common_cancel: 'Annulla',
  common_accepting: 'Accettazione…',
  common_error: 'Errore',
  common_loading: 'Caricamento…',
  common_send: 'Invia',
  common_copied: 'Copiato ✓',
  common_copy_failed: 'Copia fallita',
  common_ok: 'OK',
  common_today: 'Oggi',
  common_yesterday: 'Ieri',
  common_sending: 'Invio…',

  home_zn_midnight_hint: 'Cambia a mezzanotte UTC (tra {h}h {m}m)',
  home_temp_empty: 'Nessuna chat a tempo. Premi ⏱ su un contatto per avviarne una.',
  home_unread_aria: '{count} messaggi',
  home_temp_waiting: 'In attesa di accettazione…',
  home_temp_expires: 'Chat a tempo · scade tra {remaining}',
  home_temp_cancel: 'Annulla',
  home_temp_fallback_label: 'chat a tempo',
  home_temp_invite_title: '⏱ Invito chat a tempo',
  home_temp_invite_body: '{nick} vuole una chat effimera ({duration}).',
  home_temp_invite_hint: 'Accetta per iniziare a scambiare messaggi che spariranno alla scadenza.',
  home_temp_accept: 'Accetta',
  home_temp_reject: 'Rifiuta',
  home_temp_accepting: 'Accettazione…',
  home_contacts_empty: 'Nessun contatto. Condividi il tuo ZN- o QR per accoppiarti.',
  home_temp_chat_aria: 'Chat a tempo',
  home_btn_pair_title: 'Accoppia',
  home_btn_settings_title: 'Impostazioni',
  home_push_banner_title: 'Notifiche push',
  home_push_banner_body: 'Ricevi avvisi sonori e banner quando arriva un messaggio, anche con l\'app in background.',
  home_push_banner_ios: 'Su iPhone/iPad le notifiche push funzionano solo se aggiungi ZION alla <strong>Schermata Home</strong> (Safari → Condividi → Aggiungi a Schermata Home), poi apri l\'app dall\'icona.',
  home_push_banner_btn: 'Attiva notifiche push',
  home_push_banner_add_home: 'Come aggiungere a Home',
  home_push_banner_active: 'Notifiche push attive.',
  home_push_banner_denied: 'Notifiche bloccate. Abilitale in Impostazioni di sistema.',
  home_zn_title: 'Codice ZN- di oggi',
  home_btn_copy_zn: 'Copia ZN-',
  home_btn_open_pair: 'QR accoppiamento',
  home_section_temp: 'Chat a tempo',
  home_section_chat: 'Chat',
  home_loading: 'Caricamento…',
  home_pair_zn_title: 'Accoppia con codice ZN-',
  home_btn_zn_pair: 'Invia richiesta',
  home_copied: 'Copiato ✓',
  home_copy_failed: 'Copia fallita',
  home_swipe_delete_title: 'Elimina conversazione',
  home_swipe_delete_body: 'Vuoi eliminare questa conversazione dalla lista?',
  home_swipe_delete_confirm: 'Elimina',
  home_swipe_delete_cancel: 'Annulla',
  home_swipe_delete_label: 'Elimina',
  home_pair_request_title: 'Richiesta contatto',
  home_pair_request_body: '{name} vuole chattare.',
  home_pair_reject: 'Rifiuta',
  home_pair_accept: 'Accetta',
  home_pair_accepting: 'Accettazione…',
  home_pair_accept_failed: 'Accettazione fallita',
  home_zn_digits_err: 'Inserisci le 6 cifre dopo ZN-.',
  home_sending: 'Invio…',

  chat_rename: 'Rinomina',
  chat_rename_matrix: '[RINOMINA]',
  chat_rename_title: 'Rinomina contatto',
  chat_menu_title: 'Opzioni chat',
  chat_loading: 'Caricamento messaggi…',
  chat_reply_to: 'Rispondi a',
  chat_cancel_title: 'Annulla',
  chat_voice_lock_hint: 'Scorri in alto per bloccare la registrazione',
  chat_voice_locked: 'Registrazione bloccata — tocca Fine',
  chat_voice_stop: 'FINE',
  chat_voice_stop_title: 'Fine',
  chat_voice_preview_label: 'Anteprima vocale — ascolta prima di inviare',
  chat_voice_send: 'INVIA',
  chat_voice_send_title: 'Invia',
  chat_timer_label: 'Timer',
  chat_timer_title: 'Timer messaggio',
  chat_timer_off: 'OFF',
  chat_timer_15s: '15s',
  chat_timer_30s: '30s',
  chat_timer_1m: '1m',
  chat_timer_2m: '2m',
  chat_photo: 'Foto',
  chat_photo_title: 'Foto',
  chat_voice_hold: 'Tieni premuto per registrare',
  chat_voice_hold_title: 'Tieni premuto per registrare',
  chat_doc: 'Doc',
  chat_doc_title: 'Documento',
  chat_attach_title: 'Allegati',
  chat_input_placeholder: 'Messaggio cifrato E2E…',
  chat_send: 'Invia',
  chat_rename_modal_title: 'Rinomina contatto',
  chat_rename_nickname: 'Nickname: @{nick}',
  chat_rename_placeholder: 'Nome personalizzato',
  chat_rename_cancel: 'Annulla',
  chat_rename_save: 'Salva',
  chat_new_contact_title: 'Nuovo contatto aggiunto!',
  chat_new_contact_body: 'Vuoi assegnare un nome o un nickname a questo contatto?',
  chat_new_contact_skip: 'Salta',
  dialog_send_pairing_title: 'Contatto trovato',
  dialog_send_pairing_body: 'Vuoi inviare una richiesta di accoppiamento a questo utente?',
  dialog_send_pairing_confirm: 'Invia Accoppiamento',
  chat_action_reply: '↩ Rispondi',
  chat_action_copy: '⎘ Copia',
  chat_action_delete_me: '🗑 Elimina per me',
  chat_action_delete_all: '🗑 Elimina per tutti',
  chat_action_cancel: 'Annulla',
  chat_menu_clear_me: '🗑 Svuota chat (solo per me)',
  chat_menu_clear_all: '🗑 Elimina chat per tutti',
  chat_menu_cancel: 'Annulla',
  chat_pin: '📌 Fissa chat in alto',
  chat_unpin: '📌 Rimuovi da in alto',
  chat_pinned: 'Chat fissata',
  chat_doc_send_title: 'Invia documento',
  chat_doc_default_name: 'documento',
  chat_doc_send_hint: 'Il file sarà compresso, cifrato E2E e inviato. Max 5 MB.',
  chat_doc_cancel: 'Annulla',
  chat_doc_send_encrypted: 'Invia cifrato',
  chat_doc_too_large: '⚠️ FILE TROPPO GRANDE: il limite di sicurezza per i documenti è 5MB.',
  chat_doc_unsupported: 'Tipo di documento non supportato.',
  chat_copy_failed: 'Copia non riuscita',
  chat_confirm_delete_me: 'Eliminare questo messaggio solo per te?',
  chat_confirm_delete_all: 'Eliminare questo messaggio per tutti?',
  chat_confirm_clear_all: "Eliminare l'intera chat per tutti? Azione irreversibile.",
  chat_confirm_clear_me: 'Svuotare la chat solo per te?',
  chat_jump_new: '↓ Nuovi messaggi',
  chat_empty: 'Nessun messaggio. Scrivi qualcosa per iniziare.',
  chat_voice_err_short: 'Messaggio vocale troppo corto (minimo 1 secondo).',
  chat_voice_err_long: 'Messaggio vocale troppo lungo (massimo 2 minuti).',
  chat_voice_err_large: 'Messaggio vocale troppo grande (max 3 MB).',
  chat_voice_err_start: 'Impossibile avviare la registrazione vocale.',
  chat_destroyed: '✉ Messaggio letto e distrutto',
  chat_destroyed_title: 'Messaggio letto e distrutto',
  chat_hold_options: 'Tieni premuto per le opzioni',
  chat_reply_fallback: 'Messaggio',
  chat_timer_badge: '⏱ {seconds}s',
  chat_timer_badge_pending: '⏱ …',

  pair_zn_midnight_hint: 'Il codice ZN- cambia a mezzanotte UTC (tra {h}h {m}m).',
  pair_copied: 'Copiato ✓',
  pair_copy_failed: 'Copia fallita',
  pair_title: 'Accoppiamento',
  pair_zn_title: 'Il tuo codice ZN- di oggi',
  pair_btn_copy_zn: 'Copia codice ZN-',
  pair_tab_mine: 'Il mio QR',
  pair_tab_scan: 'Scansiona / ZN-',
  pair_qr_aria: 'QR accoppiamento',
  pair_expires_in: 'Scade tra',
  pair_btn_copy_payload: 'Copia payload',
  pair_btn_regen_qr: 'Rigenera QR',
  pair_qr_hint:
    "Mostra questo QR all'altro dispositivo. Valido 10 minuti — compatibile con l'app Android.",
  pair_expired: 'scaduto',
  pair_contact_zn_title: 'Codice ZN- del contatto',
  pair_zn_prefix_hint: 'Il prefisso <strong>ZN-</strong> è già impostato — inserisci solo le 6 cifre.',
  pair_btn_zn_request: 'Invia richiesta ZN-',
  pair_paste_title: 'Oppure incolla un QR ZION1::',
  pair_paste_hint: 'Incolla un payload <code>ZION1::</code> o carica una foto del QR.',
  pair_paste_placeholder: 'ZION1::…',
  pair_btn_pick_qr: 'Da foto / fotocamera',
  pair_btn_connect_qr: 'Connetti con QR',
  pair_zn_digits_err: 'Inserisci le 6 cifre dopo ZN-.',
  pair_sending: 'Invio richiesta…',
  pair_reading_qr: 'Lettura QR…',
  pair_qr_not_found: "QR code non trovato nell'immagine.",
  pair_zn_read_ok: 'Codice ZN- letto — conferma con Invia richiesta.',
  pair_qr_read_ok: 'QR letto — conferma con Connetti con QR.',
  pair_qr_read_err: 'Errore nella lettura del QR.',

  settings_identity_hint: 'Password e chiavi restano su questo browser. Nessun account server.',
  settings_btn_add_home: 'Guida Aggiungi a Home',
  settings_devices_title: 'Dispositivi collegati',
  settings_devices_hint:
    'Multi-device Zero-Knowledge: le chiavi viaggiano cifrate E2E. Il server è solo un relay.',
  settings_btn_link_device: 'Collega nuovo dispositivo',
  settings_btn_sync_pc: 'Sincronizza cronologia PC',
  settings_no_devices: 'Nessun dispositivo collegato.',
  settings_device_self: 'questo dispositivo',
  settings_version_prefix: 'Versione:',
  settings_ios_push_hint:
    '<strong>iPhone:</strong> notifiche = PWA da Home + Banner/Suono ON. Build ≥ <code>iospush7</code>.',
  settings_btn_force_update: 'Forza aggiornamento app',
  settings_updating: 'Aggiornamento…',
  pwa_update_banner_text: 'È disponibile una nuova versione di ZION!',
  pwa_update_banner_btn: 'Aggiorna ora',
  section_support: 'Sostieni il progetto',
  settings_support_hint:
    'ZION è indipendente, senza pubblicità e senza vendita dei tuoi dati. Se ti è utile, una donazione libera ci aiuta a migliorare l\'app.',
  settings_btn_support_coffee: 'Offrimi un caffè su Buy Me a Coffee',
  settings_support_note: 'Donazione facoltativa. Grazie per il supporto!',
  settings_push_mode_prefix: 'Modalità:',
  settings_push_hint_ios:
    '<strong>iPad/iPhone:</strong> le notifiche funzionano solo aprendo ZION dall\'icona Home Screen (Condividi → Aggiungi a Home). In Safari normale <em>non</em> sono disponibili — anche su iOS 17. Dopo l\'installazione, torna qui e tocca Abilita notifiche.',
  settings_btn_enable_push: 'Abilita notifiche push',
  settings_btn_reset_push: 'Reset & Riattiva Notifiche Push',
  settings_btn_desktop_notify: 'Notifiche desktop (PC)',
  settings_btn_disable_push: 'Disabilita notifiche',
  settings_desktop_requesting: 'Richiesta permesso desktop…',
  settings_desktop_ok: 'Notifiche desktop attive (suono + popup all\'arrivo di un messaggio).',
  settings_desktop_denied: 'Permesso negato o non supportato.',
  settings_push_no_session: 'Sessione non pronta.',
  settings_push_requesting: 'Richiesta permesso…',
  settings_push_resetting: 'Reset subscription e riattivazione…',
  settings_push_reset_ok: 'Notifiche reset e riattivate con un nuovo endpoint.',
  settings_push_disabling: 'Disattivazione in corso…',
  settings_push_active: 'Notifiche attive.',
  settings_push_disabled: 'Notifiche disabilitate.',
  settings_theme_hint: "Stessi temi dell'app ZION Android.",
  settings_theme_recommended: 'Consigliato',
  settings_font_title: 'Font chat',
  settings_font_hint: 'Il carattere si applica subito a messaggi e campo di scrittura.',
  settings_font_system: 'Default sistema',
  settings_font_mono: 'Monospace hacker',
  settings_font_serif: 'Serif elegante',
  settings_font_rounded: 'Rounded moderno',
  settings_font_condensed: 'Condensed compatto',
  settings_font_script: 'Cursive / script',
  settings_font_cyber: 'Tech cyberpunk',
  settings_font_legible: 'Alta leggibilità',
  settings_font_slab: 'Slab serif pesante',
  settings_font_terminal: 'Retro terminale',
  settings_backup_hint:
    'File JSON cifrato con passphrase (compatibile con formato Android v2). Salvalo sul PC: contatti, chat e identità web.',
  settings_backup_pass_label: 'Passphrase backup',
  settings_backup_pass_ph: 'Passphrase dedicata (min. 8 caratteri)',
  settings_btn_export_backup: 'Esporta backup',
  settings_backup_file_label: 'Ripristina da file',
  settings_backup_import_pass_label: 'Passphrase backup',
  settings_backup_import_pass_ph: 'Passphrase usata in export',
  settings_btn_import_backup: 'Ripristina backup',
  settings_backup_file_prefix: 'File: {name}',
  settings_backup_pass_min: 'La passphrase deve avere almeno 8 caratteri.',
  settings_backup_creating: 'Creazione backup…',
  settings_backup_pick_file: 'Seleziona un file backup (.enc o .enc.json).',
  settings_backup_need_pass: 'Inserisci la passphrase del backup.',
  settings_backup_restoring: 'Ripristino…',
  settings_backup_overwrite_confirm: 'Sovrascrivere i dati locali?',
  settings_modal_ok: 'OK',

  temp_duration_5m: '5 minuti',
  temp_duration_10m: '10 minuti',
  temp_duration_15m: '15 minuti',
  temp_duration_30m: '30 minuti',
  temp_duration_1h: '1 ora',
  temp_duration_6h: '6 ore',
  temp_duration_24h: '24 ore',
  temp_duration_7d: '7 giorni',
  temp_remaining_expired: 'Scaduta',
  temp_remaining_days: '{days}g {hours}h',
  temp_remaining_hours: '{hours}h {minutes}m',
  temp_remaining_minutes: '{minutes}m',
  temp_remaining_seconds: '{seconds}s',
  temp_screen_subtitle: 'Chat a tempo · messaggi effimeri',
  temp_empty: 'Nessun messaggio effimero.',
  temp_empty_hint: 'Scrivi un messaggio effimero. Sparirà allo scadere del timer.',
  temp_input_placeholder: 'Messaggio effimero…',
  temp_send: 'Invia',
  temp_waiting_accept: 'In attesa che {name} accetti la chat a tempo…',
  temp_waiting_placeholder: 'In attesa di accettazione…',
  temp_expires_in: 'Scade tra {remaining}',
  temp_duration_title: 'Chat a tempo',
  temp_duration_with: 'Con {name}',
  temp_duration_hint: 'Scegli la durata — la chat sparirà da entrambi i dispositivi.',
  temp_sending_invite: 'Invio invito…',

  voice_lock_hint: 'Scorri in alto per bloccare la registrazione',
  voice_locked: 'Registrazione bloccata — tocca Fine',

  add_home_title: 'Aggiungi a Home Screen (iPhone / iPad)',
  add_home_guide_title: 'Guida Safari',
  add_home_step1: 'Apri <strong>Safari</strong> su questa pagina (<code>zionyx.ch/app/</code>)',
  add_home_step2: 'Tocca <strong>Condividi</strong> (quadrato con freccia in alto)',
  add_home_step3: 'Scegli <strong>Aggiungi a Home</strong>',
  add_home_step4: "Apri ZION dall'<strong>icona</strong> — non da una scheda Safari",
  add_home_hint:
    "Su iOS/iPadOS 16.4+ l'app da Home supporta le notifiche Web Push e la tastiera chat. Dopo l'installazione vai su <strong>Impostazioni → Abilita notifiche</strong>.",
  add_home_btn_continue: 'Ho capito — continua',
  add_home_btn_skip: 'Salta per ora',

  search_title: 'Cerca con codice ZN-',
  search_label: 'Codice ZN- giornaliero',
  search_placeholder: 'ZN-123456',
  search_btn: 'Cerca',
  search_hint: 'Inserisci il codice ZN- del contatto. Nessuna ricerca per nickname — l\'identità è solo locale.',
  search_format_err: 'Formato: ZN-123456',
  search_resolving: 'Risoluzione codice…',
  search_invalid_code:
    "Codice non valido — chiedi un ZN- aggiornato (riapri ZION sull'altro dispositivo)",
  search_session_found: 'sessione trovata',
  search_tap_to_send: 'Tocca per inviare la richiesta',
  search_socket_not_ready: 'Sessione socket non pronta',
  search_request_sent: 'Richiesta inviata ✓',
  search_request_failed: 'Invio fallito',

  license_title: 'Attivazione licenza Web / iPhone',
  license_heading: 'Licenza',
  license_heading_updated: 'Termini aggiornati',
  license_hint:
    'Inserisci il codice <strong>ZION-XXXX-XXXX-XXXX</strong> acquistato su zionyx.ch. Sarà collegato a questo browser (chiave locale).',
  license_code_label: 'Codice licenza',
  license_code_placeholder: 'ZION-XXXX-XXXX-XXXX',
  license_btn_activate: 'Attiva licenza',
  license_beta_hint: 'Beta web: usa una licenza iPhone dedicata se disponibile.',
  license_accept_legal_err: 'Accetta Privacy e Termini per continuare',
  license_need_code: 'Inserisci il codice licenza',
  license_verifying: 'Verifica licenza…',
  license_invalid_or_used: 'Licenza non valida o già usata su un altro dispositivo',
  license_active: 'Licenza attiva ✓',
  license_err_not_found: 'Codice licenza non valido',
  license_err_conflict: 'Licenza già collegata a un altro dispositivo',
  license_err_rate_limit: 'Troppi tentativi — attendi un minuto',
  license_err_generic: 'Errore licenza',

  link_device_title: 'Collega nuovo dispositivo',
  link_device_hint:
    'Sul tuo <strong>PC</strong> apri Impostazioni → Collega nuovo dispositivo: vedrai il <strong>QR verde</strong>. Poi scansionarlo qui sotto (fotocamera o foto).',
  link_device_status_ready: '[PRONTO]',
  link_device_upload_label: 'Carica foto QR',
  link_device_btn_camera: 'Apri fotocamera / galleria',
  link_device_placeholder: 'QR link o payload…',
  link_device_btn_send_vault: 'Invia vault cifrato',
  link_device_err_invalid_qr: 'QR non valido o scaduto.',
  link_device_status_invalid: '[QR NON VALIDO]',
  link_device_status_sync_complete: '[SYNC COMPLETATA]',
  link_device_status_transfer_failed: '[TRASFERIMENTO FALLITO]',
  link_device_status_qr_detected: '[QR RILEVATO — TRASFERIMENTO...]',
  link_device_status_tap_camera: '[TOCCA IL PULSANTE VERDE — FOTOCAMERA IPHONE]',
  link_device_status_use_camera_below: '[USA FOTOCAMERA / GALLERIA QUI SOTTO]',
  link_device_status_point_camera: '[PUNTA LA FOTOCAMERA SUL QR DEL PC...]',
  link_device_status_decoding: '[DECODIFICA QR...]',
  link_device_status_qr_not_found: '[QR NON TROVATO]',
  link_device_status_decode_failed: '[DECODIFICA FALLITA]',
  link_device_status_opened_from_qr: '[APERTO DA QR — AVVIO...]',

  link_recv_title: 'Collega da telefono',
  link_recv_hint_compact:
    'Inquadra questo <strong>QR verde</strong> con il telefono (Impostazioni → Collega nuovo dispositivo). Il vault viene cifrato end-to-end.',
  link_recv_hint_auth:
    'Hai già ZION sul telefono? Inquadra questo QR con la <strong>Fotocamera</strong> — il PC si collega e entra in automatico.',
  link_recv_qr_alt: 'QR collegamento dispositivo',
  link_recv_copy_link: 'Copia link',
  link_recv_awaiting: '[IN ATTESA SCANSIONE TELEFONO — TUNNEL APERTO...]',
  link_recv_failed: '[ACCOPPIAMENTO FALLITO]',
  link_recv_tunnel_lost:
    'Tunnel interrotto — il vault potrebbe essere ancora in transito. Riprova a scansionare il QR.',

  notify_title_prefix: 'ZION — {name}',
  notify_default_body: 'Nuovo messaggio cifrato',
  notify_temp_title_prefix: 'ZION ⏱ {name}',
  notify_temp_default_body: 'Messaggio effimero',

  force_update_title:
    '🚨 AGGIORNAMENTO CRITICO OBBLIGATORIO — Per continuare a usare Zionyx in sicurezza devi scaricare l\'ultima release.',
  force_update_desc: 'Il client installato non è compatibile con la versione minima attiva sul server.',
  force_update_versions: 'Installata: v{current} · Richiesta: v{required}',
  force_update_btn: 'AGGIORNA ORA',
}
